export type IntegrationCategory =
  | 'crm'
  | 'communication'
  | 'productivity'
  | 'storage'
  | 'payments'
  | 'content'
  | 'automation'
  | 'developer'
  | 'other';

export const INTEGRATION_CATEGORY_LABELS: Record<IntegrationCategory, string> =
  {
    crm: 'CRM',
    communication: 'Communication',
    productivity: 'Productivity',
    storage: 'Storage',
    payments: 'Payments',
    content: 'Content',
    automation: 'Automation',
    developer: 'Developer',
    other: 'Other',
  };

export const INTEGRATION_CATEGORY_ORDER: IntegrationCategory[] = [
  'crm',
  'communication',
  'productivity',
  'content',
  'storage',
  'payments',
  'automation',
  'developer',
  'other',
];
